import React from 'react';
import { Star } from 'lucide-react';

const GoogleReviews = () => {
  return (
    <section className="section bg-white">
      <div className="container">
        <div className="text-center mb-12">
          <h2 className="section-title">Our Google Reviews</h2>
          <p className="text-lg text-gray-600 mb-8">
            See what our patients say about us on Google
          </p>
          <a
            href="https://g.page/r/CVCTW2gfGNHJEBM/review"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center space-x-2 text-primary-600 hover:text-primary-700 transition-colors duration-300"
          >
            <Star className="w-5 h-5" />
            <span>Leave us a review</span>
          </a>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          <div className="bg-white p-6 rounded-lg shadow-lg">
            <div className="flex items-center mb-4">
              <div className="flex-shrink-0">
                <img
                  className="h-10 w-10 rounded-full"
                  src="https://images.pexels.com/photos/415829/pexels-photo-415829.jpeg"
                  alt="Patient"
                />
              </div>
              <div className="ml-3">
                <p className="text-sm font-medium text-gray-900">Sarah Johnson</p>
                <div className="flex items-center">
                  {[...Array(5)].map((_, i) => (
                    <Star
                      key={i}
                      className="w-4 h-4 text-yellow-400 fill-current"
                    />
                  ))}
                </div>
              </div>
            </div>
            <p className="text-gray-600">
              "Amazing dental clinic! Dr. Zani and her team are professional,
              caring, and made me feel completely at ease. Highly recommend!"
            </p>
          </div>

          <div className="bg-white p-6 rounded-lg shadow-lg">
            <div className="flex items-center mb-4">
              <div className="flex-shrink-0">
                <img
                  className="h-10 w-10 rounded-full"
                  src="https://images.pexels.com/photos/220453/pexels-photo-220453.jpeg"
                  alt="Patient"
                />
              </div>
              <div className="ml-3">
                <p className="text-sm font-medium text-gray-900">Michael Smith</p>
                <div className="flex items-center">
                  {[...Array(5)].map((_, i) => (
                    <Star
                      key={i}
                      className="w-4 h-4 text-yellow-400 fill-current"
                    />
                  ))}
                </div>
              </div>
            </div>
            <p className="text-gray-600">
              "Best dental experience I've had! The clinic is modern, clean, and
              the staff is incredibly friendly. Great service!"
            </p>
          </div>

          <div className="bg-white p-6 rounded-lg shadow-lg">
            <div className="flex items-center mb-4">
              <div className="flex-shrink-0">
                <img
                  className="h-10 w-10 rounded-full"
                  src="https://images.pexels.com/photos/774909/pexels-photo-774909.jpeg"
                  alt="Patient"
                />
              </div>
              <div className="ml-3">
                <p className="text-sm font-medium text-gray-900">Emma Davis</p>
                <div className="flex items-center">
                  {[...Array(5)].map((_, i) => (
                    <Star
                      key={i}
                      className="w-4 h-4 text-yellow-400 fill-current"
                    />
                  ))}
                </div>
              </div>
            </div>
            <p className="text-gray-600">
              "Very professional and thorough. The team explained everything
              clearly and made sure I was comfortable throughout my treatment."
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default GoogleReviews;